/**
 * User Management - User Interfaces
 * Framework-agnostic TypeScript interfaces for user data
 */

// Main User interface (dynamic fields based on role)
export interface User {
  [key: string]: any; // Dynamic fields based on role selection
}

// User Details for viewing (different layouts based on profile_code)
export interface UserDetails {
  profile_code: "RTLR" | "SLSAG" | "SLS" | "others" | false;
  beat_name?: string;
  supervisor: {
    username: string;
    user_detail_name: string;
  };
  users?: UserChild[];
  status_count?: {
    Approved: number;
    Pending: number;
    Rejected: number;
    not_enrolled: number;
  };
}

// Child user (for SLSAG and SLS views)
export interface UserChild {
  ro_name?: string;
  username: string;
  user_id?: string;
  contact_no?: string;
  enrollment_status?: string;
}

// Dynamic table headers response
export interface UserTableHeaders {
  headers: string[]; // Display headers
  field_short_name: string[]; // Field keys for data mapping
}

// Bulk update request
export interface UserBulkUpdateRequest {
  type: "1" | "8" | "9" | "10"; // 1=Mobile, 8=Region, 9=State, 10=City
  excel_file: File;
  program_id: number;
}

// Bulk update response
export interface UserBulkUpdateResponse {
  message: string;
  approve_count: number;
  rejected_count: number;
  total_count: number;
  rejected_reasons: RejectedRecord[];
}

// Rejected record
export interface RejectedRecord {
  s_no: number;
  old_number: string;
  rejected_reason: string;
}

// Download users request
export interface DownloadUsersRequest {
  search_string?: string;
  user_role_id?: string;
  geographical_id?: string;
  state_code?: string;
  region_id?: string;
  city?: string;
}

// Download response
export interface DownloadResponse {
  excel: string; // Download URL
}

// API Response wrapper
export interface UserApiResponse {
  status: number;
  data:
    | User[]
    | UserDetails
    | UserTableHeaders
    | UserBulkUpdateResponse
    | DownloadResponse;
}
